import DefaultCardDesign from './DefaultCardDesign';
import CardDesign2 from './CardDesign2';
import CardDesign3 from './CardDesign3';
import CardDesign4 from './CardDesign4';
import CardDesign5 from './CardDesign5';
import CardDesign5FloatingButton from './CardDesign5FloatingButton';

export const CARD_DESIGNS = {
  default: {
    id: 'default',
    name: 'Default',
    component: DefaultCardDesign
  },
  design2: {
    id: 'design2',
    name: 'Modern',
    component: CardDesign2
  },
  design3: {
    id: 'design3',
    name: 'Gradient',
    component: CardDesign3
  },
  design4: {
    id: 'design4',
    name: 'Simple',
    component: CardDesign4
  },
  design5: {
    id: 'design5',
    name: 'Classic Card',
    component: CardDesign5
  },
  design5FloatingButton: {
    id: 'design5FloatingButton',
    name: 'Classic Card with Floating Buttons',
    component: CardDesign5FloatingButton
  }
};

export const getDesignComponent = (designName = 'design2') => {
  return CARD_DESIGNS[designName]?.component || DefaultCardDesign;
};

export const getImagePositioningProps = (layout, isCompanyLogo = false) => {
  const baseProps = {
    containerStyle: {
      position: 'absolute',
      bottom: 0,
      zIndex: 1000,
    },
    avatarStyle: {
      backgroundColor: '#ffffff',
      border: '8px solid #ffffff',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
    }
  };

  switch (layout) {
    case 'center-aligned':
      return {
        ...baseProps,
        containerStyle: {
          ...baseProps.containerStyle,
          left: '50%',
          transform: 'translateX(-50%) translateY(50%)',
        },
        logoStyle: isCompanyLogo ? {
          position: 'absolute',
          bottom: '0px',
          right: isCompanyLogo ? '-80px' : undefined,
        } : {}
      };
    case 'left-aligned':
    case 'portrait':
      return {
        ...baseProps,
        containerStyle: {
          ...baseProps.containerStyle,
          left: '23px',
          transform: 'translateY(50%)',
        },
        logoStyle: isCompanyLogo ? {
          position: 'absolute',
          bottom: '0px',
          right: isCompanyLogo ? '-30px' : undefined,
        } : {}
      };
    default:
      return baseProps;
  }
};